export default __webpack_public_path__ + "static/fineturquoisewaxdust-e00f438936583b56c2ad43ec1d8a9728.png";